export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 60,
    visible: !that.disabled && that.planningDisabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_demandDate') || '需求日期',
    field: 'demandDate',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'ElDatePicker',
      props: {
        placeholder: that.$l('INDEX.tips_select_date') || '选择日期',
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },

  {

    title: that.$l('table_label_sampleType') || '样品类型',
    field: 'proofingType',
    align: 'center',
    minWidth: 100,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'proofingType' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },

  {
    title: that.$l('table_label_demandQty') || '样品数量',
    field: 'demandQty',
    align: 'center',
    width: 130,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 1000000000,
        step: 1,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_demandRemark') || '交付要求',
    field: 'demandRemark',
    align: 'center',
    width: 300,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 100,
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        disabled: that.fabricDisabled,
        clearable: true,
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
